import React, { Component, Children } from 'react';
import { routerShape } from 'found/lib/PropTypes';
import PropTypes from 'prop-types';
// import Headroom from 'react-headroom';
import withSizes from 'react-sizes';
import { JSONLD, Generic } from 'react-structured-data';
import _isFunction from 'lodash/isFunction';
import memoizeOne from 'memoize-one';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import { handleRouteRefresh } from './utils/HandleRouteRefresh';
import AppSideEffects from './AppSideEffects';
import { handleExitEvent } from './utils/handleExitEvent';
import { environment } from '../../environment';
// import { handlePromoCodeAutoAdd } from './utils/AppHandlePromoCodeAutoAdd';
import Main from '../_common/Main/MainComponent';
import { SEO } from './SEO/SEO';
/* COMPONENTS */
import Navbar from '../_common/Navbar/NavbarComponent';
import HeaderOverlay from '../../marketplace/components/_common/ImageComponents/HeaderOverlay';

/* HELPERS */
import { smallTablet, tablet, mobile } from '../../utils/deviceWidths';
import {
  addElementClass,
  hasElementClass,
  removeElementClass,
} from '../../utils/autoHideStickyHeader';
import { filterStateData } from './FilterState';
import {
  allVarietalsAndTypes,
  newFilterState,
  disableWhiteVarietals,
  disableRedVarietals,
} from '../_common/Product/ProductFilter/filterHelpers';
import { customPCPConfig } from '../../../server/utils/customPCPConfig';
import handleLogout from './utils/handleLogout';
import { seoConfig } from '../../utils/seoConfig';

import { getCategory, getListItemToToggle, getPathFromUrl } from './AppHelpers';
import {
  closeAllListItems,
  defaultByPath,
  openListItem,
  toggleListItem,
} from './shopNavStates';
import { seoImages } from '../../../server/utils/urlConstants';
import startHubSpotObserver, {
  hubSpot,
  toggleHubSpotVisibility,
} from './HubSpotObserver';

import { DialogToggleProvider } from '../../marketplace/components/_common/_materialui/DialogToggle';
import { Dialogs } from '../../marketplace/components/_common/_materialui/DialogsEnum';

import { Case4CauseEnum } from '../_common/_context/Case4CauseEnum';
/* STYLES */
import { TYPES } from '../_common/Toast/types';
import hopeTheme from '../../styles/themes/hopeTheme';
import { subscriptionProductIdConstants } from '../../../common/sharedConstants/subscriptionProductConstantsJS';

import onehopeAscii from './onehopeAscii/onehopeAscii';
import { urlProductCatalogPage } from '../../../server/utils/routeConstants';

const mapSizesToProps = ({ width }) => ({
  containerWidth: width,
});

const propTypes = {
  viewer: PropTypes.shape({
    user: PropTypes.object,
  }),
  children: PropTypes.node.isRequired,
  router: routerShape.isRequired,
  isLoading: PropTypes.bool,
  containerWidth: PropTypes.number.isRequired,
};

const contextTypes = {
  router: PropTypes.object,
  location: PropTypes.object,
};

const childContextTypes = {
  muiTheme: PropTypes.object,
};

const defaultProps = {
  viewer: {},
  isLoading: false,
};

const shopNavDefault = {
  listItemAccount: false,
  listItemWine: true,
  listItemCoffee: false,
  listItemGifts: false,
  listItemOnehope: false,
  listItemCollection: false,
  listItemGlitter: false,
  listItemKitchen: false,
  listItemGuides: false,
  listItemTea: false,
};

function getFooterState() {
  if (window) {
    const { pathname } = window.location;
    if (pathname.match('grapeful-club-signup')) {
      return false;
    }
    if (pathname.includes('/account')) {
      return false;
    }
    if (
      pathname.match('/check-out') ||
      pathname.match('/login') ||
      pathname.match('/recovery')
    ) {
      return false;
    }
    return pathname.match('shop/product/')
      ? true
      : !Array.isArray(pathname.match('shop/'));
  }
  return true;
}

// For PDP 2.0: this will handle all /shop/product links going forward.
// PDP pages in dev will now be at localhost:4005/product/XXXXX,
// so this will strip the /shop from the url passed in since
// urlProductCatalogPage will handle that for dev/staging/prod.
function getProductUrl(value: string) {
  if (!value) return '';
  const splitUrl = value.split('/shop');
  return splitUrl && splitUrl.length > 0 ? splitUrl[1] : '';
}

class AppComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchOpen: false,
      scrollPosition: 0,
      cartNavOpen: false,
      shopNavOpen: false,
      glitterRoute: false,
      isLoggingOut: false,
      globalScrollState: 0,
      mobileFilterOpen: false,
      hasNavStateChanged: false,
      showPwpDialog: false,
      filterState: filterStateData,
      showFooter: getFooterState(), // John TODO: Refactor to not use this function
      shopNavState:
        defaultByPath(props.match.location.pathname) || shopNavDefault,
      searchCEOS: false,
      searchEvents: false,
      searchProducts: true,
      isHelpHostDialogOpen: false,
      openDialogContext: {
        openDialog: Dialogs.None,
        toggleDialog: openDialog => {
          return this.setState(prevState => ({
            openDialogContext: {
              ...prevState.openDialogContext,
              openDialog,
            },
          }));
        },
      },
      ShopLeftNav: null,
      LeftNav: null,
      CartRightNav: null,
      // Main: null,
      Case4CauseToast: null,
      EventClosedDialog: null,
      Footer: null,
      ErrorDialog: null,
    };
  }

  getChildContext = () => {
    return {
      muiTheme: getMuiTheme(hopeTheme, { userAgent: navigator.userAgent }),
    };
  };

  /* WARNING: updates to lifecycle components can have app-wide side effects.
     Changes to lifecycle components should be aOvoided without approval
     from a senior engineer.
     */
  componentDidMount() {
    onehopeAscii();

    import('../_common/Cart/CartRightNavComponent').then(module => {
      this.setState({ CartRightNav: module.default });
    });

    import('../_common/Footer/Footer').then(module => {
      this.setState({ Footer: module.default });
    });
    import('../_common/ShopNav/ShopLeftNavComponent').then(module => {
      this.setState({ ShopLeftNav: module.default });
    });
    import('../_common/LeftNav/LeftNav').then(module => {
      this.setState({ LeftNav: module.default });
    });

    import('../_common/Toast/Case4CauseToast').then(module => {
      this.setState({ Case4CauseToast: module.default });
    });
    import('../_common/EventClosedDialog/EventClosedDialog').then(module => {
      this.setState({ EventClosedDialog: module.default });
    });
    import('../Layouts/CheckoutV3/common/ErrorDialog').then(module => {
      this.setState({ ErrorDialog: module.default });
    });

    this.toggleNavAndCart();
    startHubSpotObserver();
    // this.handlePromoCodeAutoAdd();
    // this.handleReferrals();
  }

  /* eslint-disable react/sort-comp */
  // handlePromoCodeAutoAdd = () => {
  //   handlePromoCodeAutoAdd(environment);
  // };

  /* eslint-enable */

  componentDidUpdate = async () => {
    const hubSpotDiv = document.getElementById(hubSpot.containerId);
    if (hubSpotDiv) {
      toggleHubSpotVisibility(hubSpotDiv);
    }
  };

  /* WARNING: updates to lifecycle components can have app-wide side effects.
     Changes to lifecycle components should be avoided without approval
     from a senior engineer.
   */
  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      match: { location },
    } = this.props;
    const hasRouteChanged =
      location.pathname !== nextProps.match.location.pathname;
    if (hasRouteChanged) {
      const isPCP =
        !nextProps.match.location.pathname.includes('myshop') &&
        nextProps.match.location.pathname.includes('shop') &&
        !nextProps.match.location.pathname.includes('shop/product');
      if (isPCP) {
        /* reset global filter when route changes */
        this.resetGlobalFilter(nextProps);
      }
      /* handle toggling of side nav on route change */
      this.toggleNavAndCart();
      const showFooter = getFooterState();
      this.setState({ showFooter });
    }
  }

  resetGlobalFilter = nextProps => {
    const nextCategory = getCategory(nextProps.match.location.pathname);
    this.setImmState(
      d => d.mergeDeep(newFilterState),
      () => {
        this.setImmState(d => d.set('category', nextCategory));
        this.setFilterSelection(nextCategory);
        this.disableVarietals(nextCategory);
      },
    );
  };

  setImmState = (fn, cb) =>
    this.setState(
      ({ filterState }) => ({
        filterState: fn(filterState),
      }),
      cb ? () => cb() : null,
    );

  handleSearchForCEOSAndHosts = () => {
    this.setState({
      searchCEOS: true,
      searchEvents: true,
      searchProducts: false,
    });
  };

  handleSearchForProducts = () => {
    this.setState({
      searchCEOS: false,
      searchEvents: false,
      searchProducts: true,
    });
  };

  closeHelpHostDialog = () => {
    this.setState({
      isHelpHostDialogOpen: false,
    });
  };

  togglePwpDialogOpen = () => {
    this.setState({
      showPwpDialog: true,
    });
  };

  togglePwpDialogClosed = () => {
    this.setState({
      showPwpDialog: false,
    });
  };

  openHelpHostDialog = () => {
    this.setState({
      isHelpHostDialogOpen: true,
    });
  };

  handleFilterState = (fn, cb) => {
    this.setState(
      ({ filterState }) => ({
        filterState: fn(filterState),
      }),
      cb ? () => cb() : null,
    );
  };
  showPwpDialog;

  handleGlobalScrollState = (pos, path) => {
    this.setState(() => ({
      globalScrollState: pos,
    }));
  };

  handleMobileFilterOpen = () => {
    this.setState(state => ({
      mobileFilterOpen: !state.mobileFilterOpen,
    }));
  };

  disableWhiteWineVarietals = () => {
    allVarietalsAndTypes.forEach(varietal => {
      if (disableWhiteVarietals[varietal]) {
        this.setImmState(d =>
          d
            .updateIn(['disabledVarietals', varietal], () => true)
            .updateIn(['categoryStates', varietal], () => false)
            .updateIn(['wineTypes', varietal], () => false)
            .updateIn(['wineVarietals', varietal], () => false),
        );
      } else {
        this.setImmState(d =>
          d.updateIn(['disabledVarietals', varietal], () => false),
        );
      }
    });
  };

  disableRedWineVarietals = () => {
    allVarietalsAndTypes.forEach(varietal => {
      if (disableRedVarietals[varietal]) {
        this.setImmState(d =>
          d
            .updateIn(['disabledVarietals', varietal], () => true)
            .updateIn(['categoryStates', varietal], () => false)
            .updateIn(['wineVarietals', varietal], () => false)
            .updateIn(['wineTypes', varietal], () => false),
        );
      } else {
        this.setImmState(d =>
          d.updateIn(['disabledVarietals', varietal], () => false),
        );
      }
    });
  };

  updateRouteVariables = (nextCategory, pathValue) => {
    const { filterState } = this.state;
    const { router } = this.props;
    const {
      sortBy,
      filterPrice,
      filterByGiftCategories,
      filterByCause,
      filterByVarietal,
      filterByType,
    } = filterState.toJS().relayFilterVariables;
    const category = nextCategory || filterState.toJS().category;
    if (pathValue.charAt(0) === '/') {
      router.push({
        pathname: pathValue,
        state: {
          category,
          sortBy,
          filterPrice,
          filterByType,
          filterByCause,
          filterByVarietal,
          filterByGiftCategories,
        },
      });
    } else {
      this.openNewWindow(pathValue);
    }
  };

  setFilterSelection = nextCategory => {
    if (
      !Array.isArray(nextCategory.match('coffee')) &&
      !Array.isArray(nextCategory.match('kitchen'))
    ) {
      if (Array.isArray(nextCategory.match('gift'))) {
        this.setImmState(d => d.set('filterSelection', 'giftCategories'));
      } else if (
        nextCategory === 'wine-glitter' ||
        nextCategory === 'wine' ||
        nextCategory === 'wine-collection-reserve' ||
        nextCategory === 'wine-collection-core' ||
        nextCategory === 'wine-collection-vintner'
        // For Custom Category Page (LEAVE ONE EXAMPLE)
        // nextCategory === 'sparkling-sale' ||
        // nextCategory === 'flash-sale'
        // nextCategory === 'black-friday-sale'
      ) {
        this.setImmState(d => d.set('filterSelection', 'type'));
      } else if (nextCategory === 'wine-red' || nextCategory === 'wine-white') {
        this.setImmState(d => d.set('filterSelection', 'varietal'));
      } else {
        this.setImmState(d => d.set('filterSelection', 'cause'));
      }
    }
  };

  disableVarietals = nextCategory => {
    if (nextCategory === 'wine-red') {
      this.disableWhiteWineVarietals();
    } else if (nextCategory === 'wine-white') {
      this.disableRedWineVarietals();
    } else if (nextCategory === 'wine-rose') {
      this.setImmState(d =>
        d.updateIn(['disabledVarietals', 'Rosé'], () => true),
      );
    }
  };

  checkCategory = (prevCategory, nextCategory, pathValue) => {
    this.setImmState(
      d => d.mergeDeep(newFilterState),
      () => {
        this.setImmState(d => d.set('category', nextCategory));
        this.updateRouteVariables(nextCategory, pathValue);
      },
    );
  };

  handleNewCategory = (value, category) => {
    return value && !category ? getCategory(value) : category;
  };

  setNewCategory = (value, category, customRoute) => {
    const { location } = this.props.match;
    const route = location.pathname.match(/([^\/]*)\/*$/)[1];
    const routeParams =
      category || route; /* for when category undefined on reload */
    let isCustomPage = null;
    if (customPCPConfig[customRoute]) {
      isCustomPage = customPCPConfig[customRoute];
    } else isCustomPage = customPCPConfig[routeParams];
    return isCustomPage
      ? isCustomPage.category
      : this.handleNewCategory(value, category);
  };

  cartHasPreferredCustomerItems = (cartEdges: any) => {
    if (!cartEdges || !cartEdges.length) return false;
    if (
      cartEdges.find(edge => {
        const { productId } = edge.node.product;
        return (
          productId === subscriptionProductIdConstants.preferredCustomer ||
          subscriptionProductIdConstants.wineClub
        );
      })
    ) {
      return true;
    }
    return false;
  };

  handleRouteChange = (value, category = null, hasHash, customRoute = null) => {
    const { flags } = this.props;
    const { router, location } = this.props.match;
    const { pathname } = location;
    const hasRouteChanged = pathname !== value;
    const productCatalogPageV2 = flags && flags.productCatalogPageV2;
    // this.handlePromoCodeAutoAdd();
    if (value.includes('?redirect_uri=')) {
      return router.push(value);
    }
    if (value && hasRouteChanged) {
      if (
        (value === '/shop/wine/wine' && productCatalogPageV2) ||
        value === '/shop'
      ) {
        window.location.href = urlProductCatalogPage;
      } else if (value === '/shop/gifts/gift' && productCatalogPageV2) {
        window.location.href = `${urlProductCatalogPage}/gifts`;
      } else if (value && value.includes('/shop/product/')) {
        const productUrl = getProductUrl(value);
        window.location.href = `${urlProductCatalogPage}${productUrl}`;
      } else if (value === '/wine-club' && productCatalogPageV2) {
        window.location.href = `${urlProductCatalogPage}/product/maris-picks`;
      } else if (hasHash) {
        this.setImmState(d => d.mergeDeep(newFilterState));
        router.push(value);
      } else {
        const { filterState } = this.state;
        const newCategory = this.setNewCategory(value, category, customRoute);
        if (newCategory) this.setImmState(d => d.set('category', newCategory));
        const prevCategory = filterState.get('category');
        this.checkCategory(prevCategory, newCategory, value);
        if (category) {
          const toggleOpenItem = getListItemToToggle(newCategory);
          this.handleOpenListItem(toggleOpenItem);
        }
      }
    }
  };

  getSeoData = () => {
    const { pathname, href } = window.location;
    let seoTitle = '';
    let seoImage = '';
    let seoDescription = '';
    let seoAlt = '';
    let seoImageHeight = null;
    let seoImageWidth = null;
    const route = pathname.match(/([^\/]*)\/*$/)[1];
    if (seoConfig[route]) {
      seoTitle = seoConfig[route].title || seoConfig.defaultRoute.title;
      seoDescription =
        seoConfig[route].description || seoConfig.defaultRoute.description;
      seoImage = seoConfig[route].image || seoConfig.defaultRoute.image;
      seoAlt = seoConfig[route].imageAlt || seoConfig.defaultRoute.imageAlt;
      seoImageWidth =
        seoConfig[route].imageWidth || seoConfig.defaultRoute.imageWidth;
      seoImageHeight =
        seoConfig[route].imageHeight || seoConfig.defaultRoute.imageHeight;
    } else {
      seoTitle = seoConfig.defaultRoute.title;
      seoDescription = seoConfig.defaultRoute.description;
      seoImage = seoConfig.defaultRoute.image;
      seoAlt = seoConfig.defaultRoute.imageAlt;
      seoImageWidth = seoConfig.defaultRoute.imageWidth;
      seoImageHeight = seoConfig.defaultRoute.imageHeight;
    }
    return {
      facebookID: process.env.FACEBOOK_ID,
      googleId: process.env.GOOGLE_ID,
      seoImage,
      seoImageHeight,
      seoImageWidth,
      seoDescription,
      seoTitle,
      seoAlt,
      canonical: getPathFromUrl(href),
    };
  };

  isLoggingOut = value => {
    this.setState(() => ({
      isLoggingOut: value,
    }));
    if (!value) {
      this.handleAuthentication();
    }
  };

  handleLogout = (onCompleted = () => {}) => {
    const { relay } = this.props;
    this.isLoggingOut(true);
    const cb = () => this.isLoggingOut(true);
    const fn = handleLogout(cb);
    return fn(environment, onCompleted);
  };

  disableNoScroll = disableScrollClass => {
    const el = document.getElementById('body');
    const { containerWidth } = this.props;
    const { scrollPosition } = this.state;
    if (containerWidth <= tablet) {
      if (hasElementClass(el, disableScrollClass)) {
        removeElementClass(el, disableScrollClass);
        window.scrollTo(0, scrollPosition);
      }
    }
  };

  enableNoScroll = disableScrollClass => {
    const { containerWidth } = this.props;
    if (containerWidth <= tablet) {
      const el = document.getElementById('body');
      const newScrollPosition = el.scrollTop;
      this.setState(() => ({
        scrollPosition: newScrollPosition,
      }));
      addElementClass(el, disableScrollClass);
      window.scrollTo(0, newScrollPosition);
    }
  };

  handleCartClose = () => {
    const { cartNavOpen } = this.state;
    if (cartNavOpen) {
      this.disableNoScroll('disable-scroll');
      this.setState(() => ({
        cartNavOpen: false,
      }));
    }
  };

  toggleSearch = (cb = () => {}) => {
    const callback = _isFunction(cb) ? cb : () => {};
    this.setState(
      prevState => ({
        searchOpen: !prevState.searchOpen,
      }),
      callback,
    );
  };

  handleAuthentication = () => {
    const { variables } = this.props;
    const { relay } = this.props;
    const refetchVariables = () => {
      return { variables };
    };
    return relay.refetch(refetchVariables, null, handleRouteRefresh);
  };

  refetchApp = (callback = () => {}) => {
    // window.location.reload();
    // const { variables } = this.props;
    // const { relay } = this.props;
    // const refetchVariables = () => {
    //   return { variables };
    // };
    // return relay.refetch(refetchVariables, null, () => callback());
  };

  handleCartHotSwap = (callback = () => {}) => {
    this.refetchApp(callback);
  };

  // John TODO: remove the necessity of handleExitEvent from app
  handleExitEvent = (
    callback?: () => void,
    reassignSatelliteIfPossible?: boolean,
  ) => {
    return handleExitEvent({
      environment,
      callback,
      reassignSatelliteIfPossible,
    });
  };

  handleCartToggle = () => {
    const disableScrollClass = 'disable-scroll';
    const { cartNavOpen } = this.state;
    if (!cartNavOpen) this.enableNoScroll(disableScrollClass);
    else this.disableNoScroll(disableScrollClass);
    this.setState(prevState => ({
      cartNavOpen: !prevState.cartNavOpen,
    }));
  };

  handleCartOpen = () => {
    const { cartNavOpen } = this.state;
    const disableScrollClass = 'disable-scroll';
    if (!cartNavOpen) {
      this.enableNoScroll(disableScrollClass);
      this.setState(() => ({
        cartNavOpen: true,
      }));
    }
  };

  handleShopOpen = () => {
    const { containerWidth, flags } = this.props;
    const { shopNavOpen } = this.state;
    const productCatalogPageV2 = flags && flags.productCatalogPageV2;
    if (!shopNavOpen) {
      if (containerWidth <= tablet) this.enableNoScroll('disable-scroll');
      if (!productCatalogPageV2) {
        this.setState(() => ({
          shopNavOpen: true,
        }));
      }
    }
  };

  handleShopToggle = () => {
    const { containerWidth } = this.props;
    const { shopNavOpen } = this.state;
    const disableScrollClass = 'disable-scroll';
    if (!shopNavOpen && containerWidth < tablet) {
      this.enableNoScroll(disableScrollClass);
    } else {
      this.disableNoScroll(disableScrollClass);
    }
    this.setState(prevState => ({
      shopNavOpen: !prevState.shopNavOpen,
    }));
  };

  handleShopClose = () => {
    const { shopNavOpen } = this.state;
    this.disableNoScroll('disable-scroll');
    if (shopNavOpen) {
      this.setState(() => ({
        shopNavOpen: false,
      }));
    }
  };

  handleShopRouteChange = (e, value, category, customRoute = null) => {
    if (value.charAt(0) === '/' && !category) {
      this.handleRouteChange(value);
      this.handleShopTransition(value);
    } else if (value.charAt(0) === '/' && category) {
      this.handleRouteChange(value, category, false, customRoute);
    } else {
      this.openNewWindow(value);
    }
  };

  handleStaticRouteChange = (value, category = null, hasHash = false) => {
    if (value.charAt(0) === '/') {
      this.handleRouteChange(value, category, hasHash);
      this.handleCloseSideBars();
    } else {
      this.openNewWindow(value);
    }
  };

  handleShopTransition = (value = null) => {
    const { containerWidth } = this.props;
    const { pathname } = window.location;
    const isShop = value
      ? !value.includes('myshop') && value.includes('shop')
      : !pathname.includes('myshop') && pathname.includes('shop');
    if (isShop && containerWidth > tablet) {
      this.handleShopOpen();
    } else {
      this.handleCloseSideBars();
    }
  };

  handleTopNavRouteChange = (value, category, hasHash) => {
    this.handleRouteChange(value, category, hasHash);
    this.handleShopTransition(value);
  };

  openNewWindow = url => {
    const blank = window.open(url);
    blank.opener = null;
  };

  toggleNavAndCart = () => {
    /* on large desktops open shop nav automatically */
    const { containerWidth } = this.props;
    const { pathname } = window.location;
    const isShop = !pathname.includes('myshop') && pathname.includes('shop');
    if (isShop && containerWidth > tablet) {
      this.handleShopOpen();
    } else {
      this.handleCloseSideBars();
    }
  };

  handleCloseSideBars = () => {
    this.handleShopClose();
    this.handleCartClose();
  };

  handleCheckoutPage = () => {
    this.setImmState(d => d.mergeDeep(newFilterState));
    this.handleRouteChange('/checkout');
    this.handleCloseSideBars();
  };

  handleCloseAllListItems = () => {
    const newShopNavState = closeAllListItems();
    this.setState(prevState => ({
      shopNavState: { ...newShopNavState },
      hasNavStateChanged: !prevState.hasNavStateChanged,
    }));
  };

  handleToggleListItem = val => {
    const newShopNavState = toggleListItem(val);
    this.setState(prevState => ({
      shopNavState: { ...newShopNavState },
      hasNavStateChanged: !prevState.hasNavStateChanged,
    }));
  };

  handleOpenListItem = val => {
    const newShopNavState = openListItem(val);
    this.setState(prevState => ({
      shopNavState: { ...newShopNavState },
      hasNavStateChanged: !prevState.hasNavStateChanged,
    }));
  };

  handleShowFooter = val => {
    this.setState(() => ({
      showFooter: val,
    }));
  };

  getCase4CausePromoState: Case4CauseEnum = memoizeOne(c4cMode => {
    return { c4cMode: c4cMode === 'NONE' ? '' : c4cMode };
  });

  render() {
    let isShop = false;
    if (window) {
      const { pathname } = window.location;
      isShop = !pathname.includes('myshop') && pathname.includes('shop');
    }
    const {
      children,
      containerWidth,
      flags,
      // relay: { environment },
    } = this.props;
    const location = window.location.pathname;
    const page = Children.only(children);
    const {
      shopNavOpen,
      cartNavOpen,
      glitterRoute,
      shopNavState,
      isLoggingOut,
      showPwpDialog,
      shopAllRoute,
      filterState,
      globalScrollState,
      hasNavStateChanged,
      showFooter,
      mobileFilterOpen,
      searchOpen,
      searchCEOS,
      searchEvents,
      searchProducts,
      isHelpHostDialogOpen,
      openDialogContext,
      CartRightNav,
      Footer,
      // Main,
      Case4CauseToast,
      EventClosedDialog,
      ShopLeftNav,
      LeftNav,
      ErrorDialog,
    } = this.state;
    const category = filterState.get('category');
    const isCheckout = location.includes('checkout');
    const isCeoAdmin = location.includes('ceo');
    const isGrapefulFlow = location.includes('grapeful-club-signup');
    const isPDP = Array.isArray(location.match('shop/product'));

    let overlayComponent;
    if (isGrapefulFlow) {
      overlayComponent = HeaderOverlay();
    }
    const isSSOPage = location.includes('/sso');
    const isVisibleToast = !isCheckout && !isCeoAdmin && isShop;
    const outerDivStyles = isVisibleToast
      ? { marginBottom: hopeTheme.toast.height }
      : {};
    const productCatalogPageV2 = flags && flags.productCatalogPageV2;
    const {
      seoDescription,
      seoImage,
      seoTitle,
      seoImageWidth,
      seoImageHeight,
    } = this.getSeoData();
    return (
      <DialogToggleProvider value={openDialogContext}>
        <div className="application">
          <SEO
            {...{
              seoDescription,
              seoImage,
              seoTitle,
              seoImageWidth,
              seoImageHeight,
            }}
          />
          <AppSideEffects
            query={this.props.match.location.query}
            environment={environment}
          />
          <div style={outerDivStyles}>
            {/*{!mobileFilterOpen && !isSSOPage && (*/}
            {/*  <Headroom*/}
            {/*    wrapperStyle={{*/}
            {/*      zIndex: isShop && containerWidth > 991 ? 10000 : 2000,*/}
            {/*    }}*/}
            {/*    disable={searchOpen || containerWidth > smallTablet}*/}
            {/*  >*/}
            <Navbar
              {...{
                category,
                environment,
                containerWidth,
                handleAuthentication: this.handleAuthentication,
                handleCartClose: this.handleCartClose,
                handleCartHotSwap: this.handleCartHotSwap,
                handleCartToggle: this.handleCartToggle,
                handleCloseHelpHostDialog: this.closeHelpHostDialog,
                handleExitEvent: this.handleExitEvent,
                handleLogout: this.handleLogout,
                handleOpenHelpHostDialog: this.openHelpHostDialog,
                handleRouteChange: this.handleTopNavRouteChange,
                handleSearchForCEOSAndHosts: this.handleSearchForCEOSAndHosts,
                handleSearchForProducts: this.handleSearchForProducts,
                handleShopClose: this.handleShopClose,
                handleShopToggle: this.handleShopToggle,
                isHelpHostDialogOpen,
                isLoggingOut,
                location,
                overlayComponent,
                searchCEOS,
                searchEvents,
                searchOpen,
                searchProducts,
                toggleNavAndCar: this.toggleNavAndCart,
                toggleSearch: this.toggleSearch,
                flags,
              }}
            />
            {/*</Headroom>*/}
            {/*)}*/}
            {LeftNav &&
              (productCatalogPageV2 ? true : containerWidth <= mobile) && (
                <LeftNav
                  {...{
                    containerWidth,
                    location,
                    shopNavOpen,
                    environment,
                    flags,
                    handleLogout: this.handleLogout,
                    handleShopClose: this.handleShopClose,
                    handleRouteChange: this.handleShopRouteChange,
                    handleRouteStaticRoute: this.handleStaticRouteChange,
                  }}
                />
              )}
            {ShopLeftNav &&
              (productCatalogPageV2 ? false : containerWidth > mobile) && (
                <ShopLeftNav
                  {...{
                    location,
                    shopNavOpen,
                    shopNavState,
                    glitterRoute,
                    shopAllRoute,
                    containerWidth,
                    hasNavStateChanged,
                    isVisibleToast,
                    environment,
                    handleLogout: this.handleLogout,
                    handleCartClose: this.handleCartClose,
                    handleShopClose: this.handleShopClose,
                    handleShopToggle: this.handleShopToggle,
                    toggleListItem: this.handleToggleListItem,
                    closeAllListItems: this.handleCloseAllListItems,
                    handleRouteChange: this.handleShopRouteChange,
                    handleAuthentication: this.handleAuthentication,
                    handleRouteStaticRoute: this.handleStaticRouteChange,
                  }}
                />
              )}
            {CartRightNav && (
              <CartRightNav
                {...{
                  location,
                  cartNavOpen,
                  isLoggingOut,
                  showPwpDialog,
                  environment,
                  containerWidth,
                  isHelpHostDialogOpen,
                  handleShopClose: this.handleShopClose,
                  handleCartClose: this.handleCartClose,
                  handleCartToggle: this.handleCartToggle,
                  handleCartHotSwap: this.handleCartHotSwap,
                  handleCheckoutPage: this.handleCheckoutPage,
                  handleRouteChange: this.handleShopRouteChange,
                  togglePwpDialogClosed: this.togglePwpDialogClosed,
                  togglePwpDialogOpen: this.togglePwpDialogOpen,
                  handleAuthentication: this.handleAuthentication,
                  handleOpenHelpHostDialog: this.openHelpHostDialog,
                  handleCloseHelpHostDialog: this.closeHelpHostDialog,
                }}
              />
            )}
            <Main
              {...{
                page,
                flags,
                location,
                showFooter,
                filterState,
                cartNavOpen,
                shopNavOpen,
                isLoggingOut,
                showPwpDialog,
                containerWidth,
                mobileFilterOpen,
                globalScrollState,
                isHelpHostDialogOpen,
                togglePwpDialogClosed: this.togglePwpDialogClosed,
                togglePwpDialogOpen: this.togglePwpDialogOpen,
                handleExitEvent: this.handleExitEvent,
                handleLogout: this.handleLogout,
                handleCartOpen: this.handleCartOpen,
                handleShopOpen: this.handleShopOpen,
                handleShopClose: this.handleShopClose,
                handleCartClose: this.handleCartClose,
                handleCartToggle: this.handleCartToggle,
                handleShowFooter: this.handleShowFooter,
                handleCartHotSwap: this.handleCartHotSwap,
                handleFilterState: this.handleFilterState,
                handleRouteChange: this.handleTopNavRouteChange,
                handleShopRouteChange: this.handleShopRouteChange,
                handleShopTransition: this.handleShopTransition,
                handleAuthentication: this.handleAuthentication,
                handleRouteStaticRoute: this.handleStaticRouteChange,
                handleGlobalScrollState: this.handleGlobalScrollState,
                handleMobileFilterOpen: this.handleMobileFilterOpen,
                handleOpenHelpHostDialog: this.openHelpHostDialog,
                handleCloseHelpHostDialog: this.closeHelpHostDialog,
              }}
            />
            {location !== '/checkout' && showFooter && Footer && (
              <Footer
                containerWidth={containerWidth}
                handleRouteStaticRoute={this.handleStaticRouteChange}
                environment={environment}
                location={location}
                shopNavOpen={shopNavOpen}
                flags={flags}
              />
            )}
          </div>
          {isVisibleToast && Case4CauseToast && (
            <Case4CauseToast
              componentType={TYPES.DEFAULT}
              environment={environment}
              handleCartToggle={this.handleCartToggle}
            />
          )}

          <JSONLD>
            <Generic
              type="organization"
              jsonldtype="Organization"
              schema={{
                '@context': 'http://schema.org',
                '@id': '#organization',
                url: window.location.href,
                name: 'ONEHOPE Wine',
                logo: `${seoImages}onehope-default-logo.png`,
                sameAs: [
                  'https://www.facebook.com/onehopewine',
                  'https://plus.google.com/105066073739629149185/posts',
                  'https://www.instagram.com/ONEHOPE/',
                  'https://www.youtube.com/channel/UCsd0Z2BGEs9oiHOp5LpLLIQ',
                  'https://www.pinterest.com/onehopewine/',
                  'https://en.wikipedia.org/wiki/OneHope_Wine',
                ],
                contactPoint: {
                  '@type': 'ContactPoint',
                  telephone: '+1-949-329-5576',
                  email: 'support@onehopewine.com',
                  contactType: 'Customer service',
                },
              }}
            />
          </JSONLD>
          {ErrorDialog && (
            <ErrorDialog
              errorMessage="Internet is not connected. Please check your connection"
              openDialog={!navigator.onLine}
            />
          )}
          {EventClosedDialog && <EventClosedDialog environment={environment} />}
        </div>
      </DialogToggleProvider>
    );
  }
}

AppComponent.propTypes = propTypes;
AppComponent.defaultProps = defaultProps;
AppComponent.childContextTypes = childContextTypes;
AppComponent.contextTypes = contextTypes;

const EnhancedApp = withSizes(mapSizesToProps)(AppComponent);

const AppFragmentComponent = withLDConsumer()(EnhancedApp);

// eslint-disable-next-line react/display-name
export default AppFragmentComponent;
